"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _styled = require("./styled");

var _constants = require("./constants");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var isChecked = function isChecked(checked, value) {
  return Array.isArray(checked) ? checked.indexOf(value) !== -1 : checked === value;
};

var ChoiceGroup = function ChoiceGroup(props) {
  var checked = props.checked,
      children = props.children,
      data = props.data,
      defaultChecked = props.defaultChecked,
      inline = props.inline,
      input = props.input,
      invalid = props.invalid,
      required = props.required,
      role = props.role,
      otherRootProps = props.rootProps,
      size = props.size,
      type = props.type,
      restProps = _objectWithoutPropertiesLoose(props, ["checked", "children", "data", "defaultChecked", "inline", "input", "invalid", "required", "role", "rootProps", "size", "type"]);

  var rootProps = _objectSpread({
    inline: inline,
    role: role,
    size: size
  }, otherRootProps);

  var inputProps = function inputProps(value, index, inputData) {
    if (inputData === void 0) {
      inputData = {};
    }

    return _objectSpread({
      checked: checked !== undefined ? isChecked(checked, value) : undefined,
      defaultChecked: defaultChecked !== undefined ? isChecked(defaultChecked, value) : undefined,
      invalid: type === _constants.TYPE.checkbox ? undefined : invalid,
      key: index,
      required: type === _constants.TYPE.checkbox ? undefined : required,
      size: size
    }, restProps, inputData);
  };

  var inputs = null;

  if (data && input) {
    inputs = data.map(function (inputData, index) {
      return (0, _react.createElement)(input, inputProps(inputData.value, index, inputData));
    });
  } else if (children) {
    inputs = _react.Children.map(children, function (child, index) {
      return (0, _react.cloneElement)(child, inputProps(child.props.value, index));
    });
  }

  return (0, _core.jsx)(_styled.ChoiceGroupRoot, rootProps, inputs);
};

var defaultProps = {
  role: 'group',
  size: _constants.SIZE.large
};
ChoiceGroup.displayName = 'ChoiceGroup';
ChoiceGroup.defaultProps = defaultProps;
var _default = ChoiceGroup;
exports.default = _default;